import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Tile from '../tile';
import Svg from 'tio-employee/components/svg';

<template>
  <LinkTo @route="authenticated.admin.pslf.forms">
    <Tile @headerText={{t "pslf.default_approval"}} @showAdminBadge={{true}}>
      <:description>
        {{t "pslf.dashboard.widgets.approval"}}
      </:description>
      <:image>
        <Svg
          @name="online-test"
          width="100%"
          height="100%"
          role="img"
          aria-label={{t "svg.decision_making"}}
          class="lg:max-h-56 xl:max-h-full"
        />
      </:image>
    </Tile>
  </LinkTo>
</template>
